import { SessionActorType } from "@bcasmart/doxecure-commons/doxecureTypes";

import { Dashboard } from "@containers/generics/Dashboard";
import { useAuthContext } from "@hooks/useAuthContext";
import { okOrError, optlog, defaultSectionInformations } from "@utils/functions";

export const RefusedDocumentsView = () => {
    const { connectedProfileId } = useAuthContext();
    optlog(`+++ RefusedDocumentsView initialized with profile ID '${connectedProfileId}'`) ;

    return okOrError(
        connectedProfileId,
        (<Dashboard 
            title="Documents refusés"
            emptyMessage="Pas de documents refusés"
            category="refused"
            roles={[SessionActorType.Creator, SessionActorType.Expeditor, SessionActorType.Approver, SessionActorType.Signer]} 
            sectionInfos={defaultSectionInformations} 
        />),
        false,
        "Impossible d'afficher la liste des documents refusés car l'identifiant de profil de la personne connectée n'a pas pu être récupéré.",
        "Connexion invalide"
    ) ;
};